import { RouterTab } from '../models/router-tab';

export const getRouteTabWithPath = (tabs: RouterTab[], path: string) =>
    tabs.map((tab) => ({
        ...tab,
        path: tab.path ? `${path}/${tab.path}` : path,
    }));
